const salutationOptions = [
  { value: "Mr", label: "Mr" },
  { value: "Ms", label: "Ms" },
  { value: "Mrs", label: "Mrs" },
  { value: "Mdm", label: "Mdm" },
  { value: "Dr", label: "Dr" }
];

export default salutationOptions;
